import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive
} from '@angular/router';
import { CsIconModule } from '@cbuild/controls';
import { ApplicationService, AuthenticationService } from '@cbuild/core';
import {
  Feature,
  Module,
  PermissionComponent,
  SiteVisitFeaturePermissionMask
} from '@cbuild/shared';
import { Subject, takeUntil } from 'rxjs';
import { UserInfo } from '../models/user-info.model';
import { UserOrganization } from '../models/user-organization';
import { BaseUrlService } from '../services/base-url.service';
import { NavProfileDropdownComponent } from './nav-profile-dropdown/nav-profile-dropdown.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { WebLoaderComponent } from './web-loader/web-loader.component';

@Component({
  selector: 'cs-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  imports: [
    WebLoaderComponent,
    NavProfileDropdownComponent,
    CsIconModule,
    NotificationsComponent,
    RouterLink,
    CommonModule,
    RouterLinkActive
  ]
})
export class NavMenuComponent extends PermissionComponent
  implements OnInit, OnDestroy {
  public isLoading: boolean = false;
  private _onDestroy$ = new Subject();
  public userInfo?: UserInfo;
  public module = Module;
  public feature = Feature;
  public siteVisitFeaturePermissionMask = SiteVisitFeaturePermissionMask;
  public selectedOrg!: UserOrganization;
  public userType = 1;
  public hasProjects!: 'none' | 'there';
  public hasMultipleOrg = false;
  public isFloatingOpen: boolean = true;
  public isOpen: boolean = false;
  @Output()
  public initialized = new EventEmitter<void>();
  public isAuthenticated = false;

  constructor(
    private applicationService: ApplicationService,
    authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private baseUrlService: BaseUrlService,
    private cdRef: ChangeDetectorRef
  ) {
    super(authenticationService);
  }

  public ngOnInit(): void {
    this.listenUserChangesInAuthentication();
    this.listenBasicInfo(); // Depends on listenUserChangesInAuthentication
  }

  public listenBasicInfo(): void {
    this.applicationService.$userInfo
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(info => {
        this.userInfo = info;
      });
  }

  public listenUserChangesInAuthentication(): void {
    this.authenticationService.user$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(user => {
        this.initialized.emit();

        if (user) {
          this.isAuthenticated = true;
          this.applicationService.loadBasicInfo();
        } else {
          this.isAuthenticated = false;
          this.userInfo = undefined;
        }

        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next(0);
    this._onDestroy$.complete();
  }

  public navigateToSettings(): void {
    this.router.navigate(['/settings'], { relativeTo: this.route });
  }

  public navigateToSelectOrg(): void {
    this.authenticationService.navigateToSelectOrg();
  }

  public get homePageUrl(): Array<string> {
    return [this.baseUrlService.getHomeBaseURL()];
  }

  public toggleFloatingMenu() {
    this.isFloatingOpen = !this.isFloatingOpen;
  }

  public toggleMenu() {
    this.isOpen = !this.isOpen;
  }

  public logOut(): void {
    this.toggleMenu();
    this.authenticationService.logOut();
  }

  public applyPropertyFilter(event: any): void {
    console.log(event);
  }
}
